<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main>
            <div></div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'

export default {
    data: () => ({
        title: "废土童话",
        name: "f",
    }),
    components: {
        MainHeader, Footer,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.towers, .bbs {
    max-width: 1000px;
    margin: 0 auto;
}
</style>